<template>
    <div class="bg-white rounded">
        <div class="table pt-3 mb-0">
            <div class="add_license text-left justify-content-between align-items-center flex-wrap mb-3 px-3">
                <h3 class="font-weight-bold f-20 text-left mb-0 text-black">{{ $t('aiCreditLogs.title') }}</h3>
                 <span class="mt-2 f-14">{{ getAICredits }} {{ $t('aiCreditLogs.creditsAvailable') }}</span>
            </div>
            <b-table :sticky-header="'calc(100vh - 273px)'" responsive :fields="translatedFields" :items="items" hover :current-page="currentPage"
                  :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :no-local-sorting="true" :busy.sync="isBusy"
                  :show-empty="emptyTable" :fixed="true"
                  >
                  <template #cell(actor_name)="data">
                    <p class="text-pre-line mb-0">{{ data.value }}</p>
                </template>
                  <template #cell(record)="data">
                    <p class="text-pre-line mb-0">{{ data.value }}</p>
                </template>
                  <template #cell(remarks)="data">
                    <p class="text-pre-line mb-0">{{ data.value }}</p>
                </template>
            </b-table>
            <div class="entries-pagination px-0 px-sm-2">
                <div class="d-flex align-items-center flex-wrap">
                    <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                        <b-form-select v-model="perPage" :options="pageOptions" />
                    </div>
                    <div class="pagination">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                            aria-controls="my-table"></b-pagination>
                    </div>
                    <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">
                        {{ positionText }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import * as moment from "moment-timezone";
export default {
    name: "AICreditsLogs",
    data() {
        return {
            userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            items: [],
            perPage: 10,
            isBusy: false,
            currentPage: 1,
            sortBy: undefined,
            sortDesc: undefined,
            emptyTable: false,
            positionText: "",
            rows: 0,
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
        }
    },
    computed: {
        ...mapGetters(['company']),
        translatedFields() {
            return [
                { key: "created_at", label: this.$t('aiCreditLogs.dateTime'), sortable: true, thClass: 'font-table-weight-bold', stickyColumn: true },
                { key: "user_name", label: this.$t('aiCreditLogs.user'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "use_case", label: this.$t('aiCreditLogs.useCase'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "points", label: this.$t('aiCreditLogs.points'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "status", label: this.$t('aiCreditLogs.status'), sortable: true, thClass: 'font-table-weight-bold' },
            ];
        },
        getAICredits(){
            return this.company[0]?.ai_credits || 0
        },
    },
    watch: {
        perPage: {
            async handler() {
                await this.getLogsData();
            },
            immediate: true,
        },
        currentPage: {
            async handler() {
                await this.getLogsData();
            },
        },
        sortBy: {
            async handler() {
                await this.getLogsData();
            },
        },
        sortDesc: {
            async handler() {
                await this.getLogsData();
            },
        },
    },
    methods: {
        ...mapActions(['getCompanyAICreditLogs']),
        async getLogsData() {
            try {
                this.items = []
                this.isBusy = true
                let url = ""
                if (this.sortBy) {
                    url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
                }
                else {
                    url += `sort_field=created_at&sort_order=asc&`
                }
                url += `page=${this.currentPage}&page_size=${this.perPage}`
                const data = await this.getCompanyAICreditLogs(url);
                if (data.total_entries) {
                    this.rows = data.total_entries
                    const start = this.currentPage === 1 ? 1 : (this.perPage * (this.currentPage - 1)) + 1
                    const end = this.perPage * (this.currentPage - 1) + data.queryset_count
                    this.positionText = this.$t('aiCreditLogs.positionText', { start, end, total: data.total_entries })
                }
                else {
                    this.rows = 0
                    this.positionText = this.$t('aiCreditLogs.emptyPosition')
                }
                data.records.map((item) => {
                    this.items.push({
                        created_at: item.created_at ? moment.tz(item.created_at, this.userTimeZone).format("ll HH:mm") : '-',
                        use_case: item.use_case_display ? item.use_case_display : '-',
                        points: item.points ? item.points : '-',
                        user_name: item.user_name ? item.user_name : '-',
                        status: item.status === 'charged' ? 'OK': 'Failed - No Credits'
                    })
                })
                if (this.items.length === 0) this.emptyTable = true
                else this.emptyTable = false
                this.isBusy = false
            }
            catch (e) {
                this.isBusy = false
                console.log(e)
            }
        }
    },
}
</script>
<style>
.activity-log-search-field {
    width: 335px;
}

</style>